import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'react-bootstrap'
import { inject, observer } from "mobx-react"
import { parse, format } from 'date-fns'
import { DatePicker } from '../../ui/TempusDominus'

@inject("store")
@observer
export default class DateField extends React.Component {
  render() {
    const { store, field } = this.props
    const { name, placeholder, uuid, hint, required } = field
    const instance = this.props.instance || 0
    const value = store.valueFor(uuid, "text", instance)
    const errorMessage = store.errorFor(uuid, "text", instance)
    const dateFormat = store.dateFormat

    return (
      <FormGroup>
        <Form.Label htmlFor={`${uuid}-${instance}`}>{ required ? "*" : "" } {name}</Form.Label>
        <DatePicker
          id={`datetimepicker-${uuid}-${instance}`}
          value={value}
          onChange={value => store.setValueFor(uuid, "text", instance, value)}
          placeholder={placeholder}
          disabled={!store.editable}
          dateFormat={dateFormat}
          isInvalid={!!errorMessage}
        />
        { errorMessage && <Form.Control.Feedback type="invalid" style={{display: "block"}}>{errorMessage}</Form.Control.Feedback> }
        { hint && <Form.Text muted>{hint}</Form.Text > }
      </FormGroup>
    )
  }
}
